import { ReactElement } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import DashboardLayout from "../layouts/DashboardLayout";
import PermissionRoute from "../components/PermissionRoute";
import { getFirstAccessibleRoute } from "../core/common/adminPermissions";

import Dashboard from "../modules/admin/Dashboard";
import SignIn from "../modules/auth/SignIn";

import { useAuth } from "../contexts/AuthContext";

import AllUser from "../modules/admin/user/AllUser";
import AllSaleUser from "../modules/admin/user/AllSaleUser";
import RewardAchievers from "../modules/admin/user/RewardAchievers";
import UserAdd from "../modules/admin/user/UserAdd";
import SaleUserAdd from "../modules/admin/user/SaleUserAdd";
import UserDetail from "../modules/admin/user/UserDetail";
import SaleUserDetail from "../modules/admin/user/SaleUserDetail";
import NetworkTree from "../modules/admin/user/NetworkTree";
import WithdrawalList from "../modules/admin/wallet/WithdrawalList";
import HistoryList from "../modules/admin/wallet/HistoryList";
import ProfitShare from "../modules/admin/wallet/ProfitShare";
import ProductList from "../modules/admin/products/ProductList";
import ProductAdd from "../modules/admin/products/ProductAdd";
import CategoriesList from "../modules/admin/categories/CategoriesList";
import Orders from "../modules/admin/orders/OrdersList";
import OrderDetail from "../modules/admin/orders/OrderDetail";
import Coupons from "../modules/admin/Coupons";
import Banners from "../modules/admin/Banners";
import Profile from "../modules/admin/Profile";
import CategoriesAdd from "../modules/admin/categories/CategoriesAdd";
import Reviews from "../modules/admin/Reviews";
import OrderFeedback from "../modules/admin/OrderFeedback";
import AllAdmin from "../modules/admin/admins/AllAdmin";
import AdminAdd from "../modules/admin/admins/AdminAdd";
import AdminDetail from "../modules/admin/admins/AdminDetail";
import Notifications from "../modules/admin/Notifications";
import SupportList from "../modules/admin/support/SupportList";
import SupportDetail from "../modules/admin/support/SupportDetail";
import Settings from "../modules/admin/Settings";
import ClubIncome from "../modules/admin/ClubIncome";

const withPermission = (element: ReactElement) => <PermissionRoute>{element}</PermissionRoute>;

const AppRoutes = () => {
  const { token } = useAuth();
  const defaultRoute = getFirstAccessibleRoute();

  return (
    <Routes>
      {!token ? (
        <Route path="/" element={<SignIn />} />
      ) : (
        <Route element={<DashboardLayout />}>
          <Route path="/dashboard" element={withPermission(<Dashboard />)} />
          <Route path="/users" element={withPermission(<AllUser />)} />
          <Route path="/sale-users" element={withPermission(<AllSaleUser />)} />
          <Route path="/users/reward-achievers" element={withPermission(<RewardAchievers />)} />
          <Route path="/users/tree" element={withPermission(<NetworkTree />)} />
          <Route path="/add-users" element={withPermission(<UserAdd />)} />
          <Route path="/add-sale-users" element={withPermission(<SaleUserAdd />)} />
          <Route path="/users/:id" element={withPermission(<UserDetail />)} />
          <Route path="/sale-users/:id" element={withPermission(<SaleUserDetail />)} />
          <Route path="/withdrawals" element={withPermission(<WithdrawalList />)} />
          <Route path="/income-history" element={withPermission(<HistoryList />)} />
          <Route path="/profit-share" element={withPermission(<ProfitShare />)} />
          <Route path="/products" element={withPermission(<ProductList />)} />
          <Route path="/add-products" element={withPermission(<ProductAdd />)} />
          <Route path="/products/edit/:id" element={withPermission(<ProductAdd />)} />
          <Route path="/categories" element={withPermission(<CategoriesList />)} />
          <Route path="/add-categories" element={withPermission(<CategoriesAdd />)} />
          <Route path="/orders" element={withPermission(<Orders />)} />
          <Route path="/orders/:id" element={withPermission(<OrderDetail />)} />
          <Route path="/coupons" element={withPermission(<Coupons />)} />
          <Route path="/banners" element={withPermission(<Banners />)} />
          <Route path="/reviews" element={withPermission(<Reviews />)} />
          <Route path="/order-feedback" element={withPermission(<OrderFeedback />)} />
          <Route path="/notifications" element={withPermission(<Notifications />)} />
          <Route path="/support" element={withPermission(<SupportList />)} />
          <Route path="/support/:id" element={withPermission(<SupportDetail />)} />
          <Route path="/settings" element={withPermission(<Settings />)} />
          <Route path="/club-income" element={withPermission(<ClubIncome />)} />
          <Route path="/admins" element={withPermission(<AllAdmin />)} />
          <Route path="/add-admins" element={withPermission(<AdminAdd />)} />
          <Route path="/admins/:id" element={withPermission(<AdminDetail />)} />
          <Route path="/profile" element={withPermission(<Profile />)} />
        </Route>
      )}

      <Route
        path="*"
        element={<Navigate to={token ? defaultRoute : "/"} replace />}
      />
    </Routes>
  );
};

export default AppRoutes;
